<template>
  <div class="batch-allocate">
    <!-- <el-row class="cascader-style">
      <el-col>
        <el-cascader
          ref="cascaderFinanceTransformInput"
          style="width: 100%"
          v-model="financeTransformer"
          placeholder="请选择财税转化人员"
          :options="adminOptions"
          size="mini"
          :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
          clearable
          filterable
          @visible-change="handleVisibleChange($event, 'financer')"
          :filter-method="filterOptions"
        >
        </el-cascader>
      </el-col>
    </el-row> -->
    <!-- <el-row class="cascader-style">
      <el-col>
        <el-cascader
          ref="cascaderBusinessLicenceInput"
          style="width: 100%"
          v-model="businessLicencer"
          placeholder="请选择工商许可人员"
          :options="adminOptions"
          size="mini"
          :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
          clearable
          filterable
          @visible-change="handleVisibleChange($event, 'licener')"
          :filter-method="filterOptions"
        >
        </el-cascader>
      </el-col>
    </el-row> -->
    <el-row class="cascader-style">
      <el-col>
        <el-cascader
          ref="cascaderFinanceAdvisorInput"
          style="width: 100%"
          v-model="financeAdvisor"
          placeholder="请选择财税顾问人员"
          :options="adminOptions"
          size="mini"
          :props="{ expandTrigger: 'hover',multiple: true, emitPath: false }"
          clearable
          filterable
          @visible-change="handleVisibleChange($event, 'advisor')"
          :filter-method="filterOptions"
        >
        </el-cascader>
      </el-col>
    </el-row>
    <el-row class="cascader-style">
      <el-col>
        <el-cascader
          ref="cascaderSharerInput"
          style="width: 100%"
          v-model="sharer"
          placeholder="请选择共享人员"
          :options="adminOptions"
          size="mini"
          :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
          clearable
          filterable
          @visible-change="handleVisibleChange($event, 'sharer')"
          :filter-method="filterOptions"
        >
        </el-cascader>
      </el-col>
    </el-row>

    <el-row class="dialog-footer">
      <el-button size="mini" type="primary" @click="handleBatchShareSubmit"
        >确 定</el-button
      >
    </el-row>
  </div>
</template>

<script>
import { filterKeywordOptions } from '../../../lib/cascaderUtils.js';

export default {
  name: "BatchAllocate",
  props: {
    multipleSelects: Array,
    clearCascader: Boolean,
  },
  data() {
    return {
      financeTransformer: [],
      businessLicencer: [],
      financeAdvisor: "",
      sharer: [],
      adminOptions: [],
    };
  },
  watch: {
    clearCascader(newVal) {
      if (newVal) {
        this.financeTransformer = [];
        this.businessLicencer = [];
        this.financeAdvisor = '';
        this.sharer = [];
      }
    },
  },
  methods: {
    handleVisibleChange(visible, fieldInput) {
      let cascaderInput = null;
      if (visible) {
        if (fieldInput === "financer") {
          cascaderInput = this.$refs.cascaderFinanceTransformInput;
        } else if (fieldInput === "licener") {
          cascaderInput = this.$refs.cascaderBusinessLicenceInput;
        } else if (fieldInput === "advisor") {
          cascaderInput = this.$refs.cascaderFinanceAdvisorInput;
        } else if (fieldInput === "sharer") {
          cascaderInput = this.$refs.cascaderSharerInput;
        }
        if (cascaderInput && cascaderInput.$refs.input) {
          cascaderInput.$refs.input.focus();
        }
        this.$nextTick(() => {
          this.loadAdminer();
        });
      } else {

      }
    },
    handleBatchShareSubmit() {
      const cids = this.multipleSelects.map((item) => item.id);
        if (this.financeTransformer.length <= 0 && this.businessLicencer.length <= 0 && !this.financeAdvisor && this.sharer.length <= 0) {
            this.$message.error('请选择分配的人员');return false;
        }
      this.$axios
        .post("/api/admin/batch_share", {
          financeTransformer: this.financeTransformer,
          businessLicencer: this.businessLicencer,
          financeAdvisor: this.financeAdvisor,
          sharer: this.sharer,
          companyIds: cids,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.financeTransformer = [];
            this.businessLicencer = [];
            this.financeAdvisor = '';
            this.sharer = [];
            this.$emit("data-updated");
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    loadAdminer() {
      this.$axios
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminOptions = data.data;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {},
};
</script>

<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
.cascader-style {
    margin-bottom: 0.3rem;
}
.dialog-footer{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/companies/components/BatchAllocate.vue